import { Box, createStyles, useMantineTheme, ActionIcon, Stack } from "@mantine/core";
import React from "react";
import { tokens } from "@blurb/codex-react";
import { IconV3 } from "@rpi/openapi-core";
import { useClipboard } from "@mantine/hooks";
import { Label, Body } from "./Typography";

const useStyles = createStyles({
  content: {
    color: tokens.color.semantic.text.bold,
    gap: tokens.spacing[1],
  },
  body: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacing[1],
    justifyContent: "space-between",
    wordBreak: "break-word",
    "& > :first-child": { overflow: "hidden", textOverflow: "ellipsis" },
  },
});

interface RpiTextFieldProps {
  label?: string | React.ReactNode;
  children: React.ReactNode;
  copyable?: boolean;
  inheritStyles?: boolean;
}

export const RpiTextField: React.FC<RpiTextFieldProps> = ({ label, children, copyable, inheritStyles }) => {
  const { classes } = useStyles();
  const clipboard = useClipboard();
  const theme = useMantineTheme();

  return (
    <Stack className={classes.content}>
      {label && <Label>{label}</Label>}
      <Box className={classes.body}>
        {inheritStyles ? children : <Body>{children}</Body>}
        {copyable && (
          <ActionIcon
            onClick={() => clipboard.copy(typeof children === "string" ? children : "")}
            sx={(theme) => ({
              "&:hover": {
                backgroundColor: theme.other.semanticColors.bg.graySubtlerHover,
              },
            })}
          >
            {clipboard.copied ? (
              <IconV3
                icon="check_circle"
                color={theme.other.semanticColors.icon.brand}
                size={inheritStyles ? "inherit" : 20}
              />
            ) : (
              <IconV3
                icon="content_copy"
                color={theme.other.semanticColors.icon.brand}
                size={inheritStyles ? "inherit" : 20}
              />
            )}
          </ActionIcon>
        )}
      </Box>
    </Stack>
  );
};
